import React from "react";

const SecondForm = ({ currentStep, children }) => {
  if (currentStep !== 2) {
    return null;
  }
  return <>{children}</>;
};

export default SecondForm;
